var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"p-0 rounded-circle border",attrs:{"src":_vm.src,"alt":"","height":"45","width":"45"},on:{"click":_vm._onPress}})}
var staticRenderFns = []

export { render, staticRenderFns }